import { ButtonGroup, HStack } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { GenerateRenButton } from '../../common/components/generate-ren-button';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { ReactivateEventButton } from '../../common/components/reactivate-event-button';
import { useEventMetadataStore } from '../event-panel-form/event-metadata';
import { EventExportButton } from './event-export-button';

export const ClearedEventFooter = observer(function ClearedEventFooter() {
    const eventId = useWorkspacePanel().linkedEntityId;
    const enabledFeatures = useEnabledFeatures();
    const metadata = useEventMetadataStore();
    const agencyEventNumber = metadata.state.metadata?.agencyEventNumber;

    return eventId ? (
        <HStack w="100%">
            {enabledFeatures.canReactivateEvent && <ReactivateEventButton eventId={eventId} />}
            <ButtonGroup style={{ flex: 1, justifyContent: 'flex-end' }}>
                <GenerateRenButton eventId={eventId} />
                {agencyEventNumber && (
                    <EventExportButton eventId={eventId} eventNumber={agencyEventNumber} />
                )}
            </ButtonGroup>
        </HStack>
    ) : null;
});
